import { CommonModule, isPlatformBrowser } from "@angular/common";
import { ChangeDetectorRef, Component, inject, OnInit, PLATFORM_ID } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { GtmService } from "../../../../core/services/gtm.service";
import { SeoService } from "../../../../shared/services/seo.service";
import { MatDialog } from "@angular/material/dialog";
import { environment } from "../../../../../environments/environment";
import { Router } from "@angular/router";
import { AuthDialogComponent } from "../sales-auth-dialog/sales-auth-dialog";
import { AuthService } from "../../../../core/services/auth.service";
import { tap } from "rxjs";

@Component({
  selector: 'app-sales-steps',
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule
  ],
  standalone: true,
  templateUrl: './sales-agent-steps.html',
  styleUrl: './sales-agent-steps.scss',
})
export class SalesAgentSteps implements OnInit {
  private dialog = inject(MatDialog);
  private router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  private gtm = inject(GtmService);
  private seo = inject(SeoService);
  private authService = inject(AuthService);

  platformId = inject(PLATFORM_ID);
  accountCreated = false;

  ngOnInit(): void {
    this.authService.isAuthenticated().pipe(tap(response => {
      console.log('isAuth', response);
      this.accountCreated = response;
    })).subscribe();
    

    if (isPlatformBrowser(this.platformId)) {
      document.body.scrollTop = 0;
      this.gtm.pageView({
        page_path: '/sales/steps',
        page_title: 'Sales Agent Steps | Horizinns'
      });

    }
    this.seo.updateMetaTags(
      'Sales Agent Steps', 
      'Outline of the process and benefits of becoming a sales agent with Horizinns', 
      undefined, 
      `${environment.appUrl}/sales/steps`);

    console.log('account created ', this.accountCreated, this.authService.currentUser());
  }

  goToContact() {
    this.router.navigate(['contact', 'sales']);
  }

  goToSalesTerms() {
    this.router.navigate(['common-forms'], { queryParams: { form: 'terms' } });
  }

  goToCreateAccount() {
    if (this.accountCreated) return;

    const ref = this.dialog.open(AuthDialogComponent, {
      width: '500px',
      maxWidth: '95vw',
      panelClass: 'glass-dialog-panel', // Optional: use this to override mat-card padding/backgrounds if it looks nested
      backdropClass: 'glass-dialog-backdrop'
    });

    ref.afterClosed().subscribe((result) => {
      if (result === true) {
        this.accountCreated = true;
        this.cdr.detectChanges();
      }
    });
  }
}